import { Address } from "viem"
import { abstract, abstractTestnet } from "viem/chains"

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000' as Address
export const MAX_UINT256 = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

///////////////////
export const IS_TESTNET = import.meta.env.VITE_IS_TESTNET

export const WWW = import.meta.env.VITE_WWW
export const API_URL = import.meta.env.VITE_API_URL
export const GRAPHQL_URL = import.meta.env.VITE_GRAPHQL_URL
export const RPC_URL = process.env.NODE_ENV === 'production' ? import.meta.env.VITE_RPC_URL : import.meta.env.VITE_DEV_RPC_URL

export const MULTIPLE_PRECISION = 100000
export const MULTIPLE_PRECISION_DECIMALS = 5

export const ABS_CHAIN = IS_TESTNET ? abstractTestnet : abstract

export const USD_DECIMALS = 2;
export const USD_SCALE = 100n; // 10 ** 2

export const WETH_CONTRACT_ADDRESS = import.meta.env.VITE_WETH_CONTRACT_ADDRESS
export const USDC_CONTRACT_ADDRESS = import.meta.env.VITE_USDC_CONTRACT_ADDRESS
export const MULTICALL3_CONTRACT_ADDRESS = ABS_CHAIN.contracts.multicall3.address
export const VOTE_CONTRACT_ADDRESS = '0x3B50dE27506f0a8C1f4122A1e6F470009a76ce2A' as Address

export const COMMIT_REVEAL_CONTRACT_ADDRESS = import.meta.env.VITE_COMMIT_REVEAL_CONTRACT_ADDRESS
export const HONEY_DROPPER_CONTRACT_ADDRESS = import.meta.env.VITE_HONEY_DROPPER_CONTRACT_ADDRESS as Address
